export default "__VITE_ASSET__BiFgz4oJ__"